import React from "react";
import Slider from "./components/Slider";
import ContentShow from "./components/ContentShow";
import "../css/pages/mainPage.scss";
import HeroComponent from "./components/Hero";
import GallerySection from "./components/Gallery";
import Services from "./components/Services";
import Stats from "./components/Stats";

interface Props {}
const MainPage: React.FC<Props> = (Props) => {
  return (
    <div className="mainPage">
      <HeroComponent />
      <Slider category="posts" />
      <ContentShow category="posts" />
      <Services />
      <GallerySection />
      <Stats />
    </div>
  );
};

export default MainPage;
